module.exports = __webpack_public_path__ + "img/logo.b16c9d99.png";